export default {
  menu:{ // 登錄
    home: '首頁',
    foundApply: '開戶申請',
    foundTikTokBatch: 'TikTok 批量開戶',
    account: '賬戶管理',
    accountList: '賬戶列表',
    accountRecord: '開戶記錄',
    subAccountList: '成員列表',
    accountRecharge: '智能充值',
    accountMonitor: '帳戶監控',
    check: '對賬管理',
    checkWallet: '錢包充值記錄',
    checkBalance: '錢包明細',
    checkCreditBalance: '信用余額明細',
    helpCenter: '幫助中心',
    checkCreditLimit: '授信變動記錄',
    monthSettlement: '月結賬單',
    marketingTool: '紅人行銷工具',
    crossBorderBrowser: '跨境瀏覽器',
    storeOperationTools: 'TK店鋪營運工具',
    AdvertisementManagement:'廣告管理',
    TikTok:'TikTok',
    Partner:'合作夥伴',
    USCloudPhone:'美國雲端手機號',
    AccountOpeningManagement:'開戶管理',
    cooperativePartner:'合作夥伴',
    subClient: '子客户管理',
    subClientList: '子客户列表',
    subClientAdvertiserList: '子客户广告列表',
    subClientCheckWallet: '交易记录',
    subClientAccountRecord: '子客户开户记录',
    promotion: '推廣',
    agentSubAccount: '二代子帳號清單',
    mediaAuth: '媒體管理',
    advertiserTransaction: '廣告交易明細',
    advertiserTransfer: '廣告轉移明細',
    subAccount: '成員管理',
    accountMonitorEr: '帳戶監控',
    CheckConsume: '廣告消耗明細',

  }, crumb:{
    PassedInThePast30Days: '近30天已通過',
    ApplyForAccountOpening: '申請開戶',
    PopularEntrance: '熱門入口',
    AccountOpeningApplication2: '開戶申請',
    IntelligentRecharge: '智能充值',
    AccountReconciliationManagement: '對賬管理',
    account: '賬戶管理',
    WalletRecharge: '錢包充值',
    RechargeAmount: '充值金額',
    EnterAmount: '請輸入充值金額',
    PaymentMethod: '支付方式',
    Cancel:'取消',
    ConfirmRecharge:'確認充值',
    Message1:"您充值到平臺帳戶的美金餘額，",
    Message2:"不包含已經充值到媒體平臺的金額",
    Message3:"充值到媒體平臺廣告帳戶的總餘額",
    Message4:"平臺授予的信用額度餘額，",
    Message5:"計算管道為：總授信額度-已使用額度",
    Message6: "新增功能上線啦! 快來幫助中心查看如何使用",
    Validity: '有效期',
    home: '首頁',
    foundApply: '開戶申請',
    Account: '賬戶管理',
    AccountList: '賬戶列表',
    AccountRecord: '開戶記錄',
    AccountRecharge: '智能充值',
    AccountMonitor: '帳戶監控',
    Check: '對賬管理',
    CheckWallet: '錢包充值記錄',
    CheckBalance: '錢包明細',
    CheckCredit: '信用余額明細',
    CheckConsume: '廣告消耗明細',
    CheckLimit: '授信變動明細',
  }, header:{
    Settings: '帳號設置',
    LogOut: '退出'
  }, home:{ // 登錄
    AssetOverview: '資産概覽',
    wallet: '錢包余額',
    AdvertisingAccount: '廣告賬戶余額',
    PlatformWallet: '平台錢包',
    creditBalance: '信用余額',
    RechargeWallet: '充值錢包',
    ViewDetails: '查看明細',
    ActiveAccountBalance: '活躍賬戶余額',
    FrozenBalance: '被凍結余額',
    PlatformGifts: '平台贈金',
    UsedCredit: '已使用授信',
    CreditLimit: '授信額度',
    AccountOpeningApplication: '開戶申請',
    inReview: '審核中',
    ToBeModified: '待修改',
    GoAndModifyIt: '去修改',
    DisableRate:'消耗封戶率',
    AccountDisableRate:'帳戶封戶率',
    PassedInThePast30Days: '近30天已通過',
    ApplyForAccountOpening: '申請開戶',
    PopularEntrance: '熱門入口',
    AccountOpeningApplication2: '開戶申請',
    IntelligentRecharge: '智能充值',
    AccountReconciliationManagement: '對賬管理',
    account: '賬戶管理',
    WalletRecharge: '錢包充值',
    RechargeAmount: '充值金額',
    EnterAmount: '請輸入充值金額',
    PaymentMethod: '賬戶管理',
    Cancel:'取消',
    ConfirmRecharge:'確認充值',
    Message1:"您充值到平臺帳戶的美金餘額，",
    Message2:"不包含已經充值到媒體平臺的金額",
    Message3:"充值到媒體平臺廣告帳戶的總餘額",
    Message4:"平臺授予的信用額度餘額，",
    Message5:"計算管道為：總授信額度-已使用額度"
  }, login:{ // 登錄
    FreeRegistration: '免費注冊',
    IHaveReadAndAmWillingToAccept: '我已閱讀並願意接受',
    TermsOfService: '《服務條款》 ',
    and: '和',
    PrivacyStatement: '《隱私聲明》',
    ElMPleaseEnterYourPhoneNumber: '請輸入手機號碼',
    ElMPleaseEnterYourEmailNumber: '請輸入郵箱號碼',
    ElMPleaseEnterTheVerificationCode: '請輸入驗證碼',
    ElMPleaseEnterPassword: '請輸入密碼',
    PleaseAgreeToTheServiceAgreement: '請同意服務協議',
    SuccessfullySentSMSVerificationCode: '成功發送短信驗證碼',
    SuccessfullySentEmailVerificationCode: '成功發送郵件驗證碼',
    UserAgreement: '《使用者協定》',
    UserAgreementAdvertisingComplianceManagementSystem: '《廣告合規管理制度》',
    ServiceAndInformationCollectionAgreement: '《服務及資訊收集協定》',
    AccountLogin: '帳號登入',
    EmailLogin: '郵箱登入',
    VerificationCodeLogin: '驗證碼登錄',
    title: '登錄',
    NoAccount: '沒有賬號？',
    register: '去注冊',
    WelcomeToLogin: '歡迎登錄',
    PleaseEnterYourPhoneNumberOrEmailAddress: '請輸入手機號或郵箱',
    PleaseEnterYourLoginPassword: '請輸入登錄密碼',
    ForgotPassword: '忘記密碼？',
    logOn: '登錄',
    LoginSuccess:'成功登入，正在跳轉。。。',
    Mail: '郵箱',
    Password: '密碼',
    VerificationCode: '驗證碼',
    MasterAccountLogin: '切換主帳號登入',
    SubAccountLogin: '切換子帳號登入'
  }, register:{ // 注冊
    title: '注冊',
    ExistingAccount: '已有賬號？',
    GoLogIn: '去登陸',
    WelcomeToRegister: '歡迎注冊',
    PleaseEnterYourPhoneNumber: '請輸入手機號（作為登錄的首選賬號）',
    LoginPassword: '註意:密碼需包含大小寫字母及數字（字符數量不限）',
    InvitationCode:'邀請碼',
    PlaInvitationCode:'註意:有邀請碼請輸入,無不需要輸入',
    ObtainVerificationCode: '獲取驗證碼',
    PleaseEnterYourFrequentlyUsedEmail: '請輸入您常用郵箱（作為備選賬號，此項非必填）',
    PleaseEnterA6_20DigitLoginPassword: '請輸入6-20位登錄密碼（需包含大小寫字母和數字）',
    FreeRegistration: '免費注冊',
    IHaveReadAndAmWillingToAccept: '我已閱讀並願意接受',
    TermsOfService: '《服務條款》 ',
    and: '和',
    PrivacyStatement: '《隱私聲明》',
    ElMPleaseEnterYourPhoneNumber: '請輸入手機號碼',
    ElMPleaseEnterYourEmailNumber: '請輸入郵箱號碼',
    ElMPleaseEnterTheVerificationCode: '請輸入驗證碼',
    ElMPleaseEnterPassword: '請輸入密碼',
    PleaseAgreeToTheServiceAgreement: '請同意服務協議',
    SuccessfullySentSMSVerificationCode: '成功發送短信驗證碼',
    SuccessfullySentEmailVerificationCode: '成功發送郵件驗證碼',
    UserAgreement: '《使用者協定》',
    UserAgreementAdvertisingComplianceManagementSystem: '《廣告合規管理制度》',
    ServiceAndInformationCollectionAgreement: '《服務及資訊收集協定》',
    AccountLogin: '帳號登入',
    EmailLogin: '郵箱登入',
  },forget:{// 找回密碼
    title: '找回密碼',
    NoAccount: '沒有賬號？',
    register: '去注冊',
    RetrievePassword: '找回密碼',
    PleaseEnterYourPhoneNumber: '請輸入手機號碼',
    PleaseEnterTheMobileVerificationCode: '請輸入手機驗證碼',
    SuccessfullySentSMSVerificationCode: '成功發送短信驗證碼',
    ObtainVerificationCode: '獲取驗證碼',
    ReturnToLogin: '返回登錄',
    VerifyWithEmail: '用郵箱驗證',
    PleaseEnterYourEmailNumber: '請輸入郵箱號碼',
    PleaseEnterTheEmailVerificationCode: '請輸入郵箱驗證碼',
    SuccessfullySentEmailVerificationCode: '成功發送郵件驗證碼',
    VerifyWithMobilePhone: '用手機驗證',
    Verify: '驗證',
    NewPassword:'請輸入新密碼',
    AgainNewPassword:'請再次輸入新密碼',
    NewPasswordLogin:'修改成功，請重新登入',
  },loginSMS:{// 驗證碼登錄
    title: '驗證碼登錄',
    NoAccount: '沒有賬號？',
    register: '去注冊',
    WelcomeToLogin: '歡迎登錄',
    PleaseEnterYourPhoneNumber: '請輸入手機號',
    PleaseEnterTheMobileVerificationCode: '請輸入手機驗證碼',
    SuccessfullySentSMSVerificationCode: '成功發送短信驗證碼', 
    ObtainVerificationCode: '獲取驗證碼',   
    PleaseEnterYourEmailAddress: '請輸入郵箱',
    PleaseEnterTheEmailVerificationCode: '請輸入郵箱驗證碼',
    SuccessfullySentEmailVerificationCode: '成功發送郵件驗證碼',
    PasswordLogin: '密碼登錄',
    EmailVerificationCodeLogin: '郵箱驗證碼登錄',
    MobileVerificationLogin: '手機驗證登錄',
    logOn: '登錄'
  },password:{ // 修改密碼
    title: '修改密碼',
    ChangePassword: '修改密碼',
    PleaseEnterANewPassword: '請輸入6-20位新密碼（需包含大小寫字母和數字）',
    PleaseEnterANewPassword2: '請輸入新密碼',
    PleaseEnterTheNewPasswordAgain: '請再次輸入新密碼',
    ConfirmModifications: '確認修改',
    ReturnToLogin: '返回登錄',
    ModificationSuccessful: '修改成功，請重新登錄'
  },foundApply:{ // 開戶申請
    OfficialAuthorizedServiceProvider: '官方授權服務商',
    TikTok: '抖音國際版，風靡全球短視頻社交平台，海量新潮年輕用戶，通過強導流強曝光的短視頻內容帶來更高轉化率。',
    Google: '全球最大的搜索引擎公司，擁有近30億月活用戶，在客戶搜索您的産品或服務的那一刻，恰當其時展示廣告。',
    Facebook: '按點擊或每千流量付費，運行速度非常快，而且非常易用。另外，廣告主還可以通過報表更快的了解不同廣告的運行狀況。',
    ApplyNow: '立即申請',
    BatchApply: '批量開戶',
    ComingSoon: '即將開放',
    Kwai: 'Kwai致力於支持用戶分享人生經歷，為用戶和企業創造價值，我們相信人與人之間的交流和互動會帶來商機，與用戶建立聯繫，讓您的品牌受益。',
    TemporarilyClose: '暫停開放',
  },foundTikTok:{ // 開戶申請TikTok
    Tip: "營業執照要求:",
    Tip1:"1.請盡量提供清晰且無水印的大陸地區營業執照證件，且必須是真實最新的版本",
    Tip2:"2.確保營業執照下方的二維碼可識別",
    Tip3:"3.提交的營業執照或組織機構代碼證照片不清晰或不完整會導致不匹配，核對無誤後再提交開戶申請",
    Tip1Sea:"1.請盡量提供清晰且無水印的東南亞營業執照證件，且必須是真實最新的版本",
    Port: "端口選擇",
    PortTip: "請選擇端口",
    PortCnob: "國內CNOB",
    PortSea: "東南亞",
    PortAreaMismatch: "公司註冊地與所選端口不一致。國內CNOB請選中國，東南亞請選對應國家",
    BusinessLicense: '營業執照',
    BusinessLicenseTip: '請上傳營業執照附件',
    LicenseTip: '營業執照是指證明您的公司合法性的憑證。 請上傳 PNG、JPG、JPEG 文件',
    CompanyRegistrationLocation: '公司注冊地',
    CompanyRegistrationLocationTip: '請選擇公司注冊地',
    CompanyName: '公司名稱',
    CompanyNameTip: '請輸入企業名稱',
    BusinessLicenseNumber: '營業執照編號',
    BusinessLicenseNumberTip: '請輸入營業執照編號',
    AccountTimeZone: '賬號時區',
    AccountTimeZoneTip: '請選擇賬號時區',
    PromotionLink: '推廣鏈接',
    PromotionLinkTip: '請輸入推廣鏈接',
    PromotionLinkTip2: '請輸入正確鏈接格式',
    ContactEmail: '聯系人郵箱',
    ContactEmailTip: '請輸入聯系人郵箱',
    ContactEmailTip2: '請輸入正確郵箱格式',
    BusinessCenterID: '商務中心ID',
    BusinessCenterIDTip: '請輸入商務中心ID',
    Reset: '重置',
    Submit: '提交',
  }, foundTikTokBatch: {
    Intro: '同一份資質提交多條開戶申請。系統按隊列逐條向 TikTok 建戶，單批 50 至 500 條。建戶成功後進入 TikTok 審核，審核時間不計入本次提交。',
    PreviewNote: '當前是前台流程預覽。提交後只在本頁模擬逐條進度，不會在 TikTok 建立賬戶。能否填寫開戶清單，由後台白名單決定。',
    PreviewMissing: '未找到這個預覽批次，請重新提交。',
    AccessChecking: '正在確認開通狀態',
    AccessClosedTitle: '批量開戶未開通',
    AccessClosed: '當前賬號不在批量開戶白名單中。請聯繫運營在後台「開戶審核」裡把用戶名加入白名單，加入後即可使用，不需要再申請審批。',
    AccessError: '暫時無法確認開通狀態，請稍後重試。',
    AccessRetry: '重新檢查',
    Qualification: '開戶資質',
    Accounts: '賬戶清單',
    AccountName: '賬戶名稱',
    AccountNameTip: '同一商務中心內不可重名',
    DramaName: '劇目名稱',
    DramaTip: '一個賬戶對應一個劇目，可留空',
    Paste: '粘貼名單',
    PasteTitle: '粘貼賬戶名單',
    PasteTip: '每行一條。也可寫成「賬戶名稱,劇目名稱」。',
    PastePlaceholder: '短劇A-001,短劇A\n短劇A-002,短劇A',
    AddRow: '添加一行',
    Clear: '清空清單',
    Generate: '按序號生成',
    Prefix: '名稱前綴',
    StartNo: '起始編號',
    GenCount: '生成數量',
    Digits: '編號位數',
    Append: '加入清單',
    Valid: '有效',
    Duplicate: '重名',
    EmptyName: '未填名稱',
    OverLimit: '超過 500 條，請拆批提交',
    UnderLimit: '至少填寫 1 條賬戶名稱',
    LimitHint: '建議單批 50 至 500 條',
    Submit: '提交批量開戶',
    Single: '單條開戶',
    Result: '批次進度',
    BatchNo: '批次號',
    Pending: '待處理',
    Processing: '處理中',
    Success: '成功',
    Failed: '失敗',
    Unknown: '結果未知',
    All: '全部',
    AdvertiserId: '廣告賬戶 ID',
    FailReason: '失敗原因',
    RetryFailed: '只重提失敗項',
    RetryUnknown: '回查結果未知',
    Continue: '再開一批',
    ViewRecord: '查看開戶記錄',
    NoBatchNo: '未返回批次號，請重試',
    Polling: '正在逐條建戶，請留在本頁查看進度',
    StillRunning: '處理時間較長，可稍後刷新本頁查看',
    Refresh: '刷新進度',
    Total: '共',
    Unit: '條',
    Filter: '篩選',
    Remove: '移除',
    ConfirmClear: '清空當前賬戶清單？',
    NameRequired: '請為每一行填寫賬戶名稱，並去掉重名',
    DramaOptional: '劇目',
  },AccountList:{
    Account: '帳號名稱',
    RequestID: '賬戶ID',
    RequestIDTip: '請輸入賬戶ID',
    AccountTip: '請輸入帳號名稱',
    AccountEntity: '開戶主體',
    Media: '媒體平台',
    status: '狀態',
    AccountID: '帳號名稱/賬戶ID',
    Currency: '幣種',
    Balance: '余額',
    DailyBudget: '每日預算',
    AccountRecharge: '賬戶充值',
    DeductionTransfer: '減款轉賬',
    BindUnbind: '綁定/解綁',
    AccountRenaming: '賬戶更名',
    Fail: '未通過',
    Passed: '已通過',
    InReview: '審核中',
    Operate: '操作',
    Reset: '重置',
    Search: '搜索',
    BatchRecharge: '批量充值',
    BatchZeroing: '批量清零',
    BatchBinding: '批量綁定/解綁',
    ViewBC: '查看BC',
    NewName: '新名稱',
    NewNameTip: '請輸入賬戶新名稱',
    Cancel: '取消',
    Confirm: '提交',
    ConfirmModification: '確認修改',
    RechargeAmount: '充值金額',
    RechargeAmountTip: '請輸入充值金額',
    DailyBudgetTip: '請輸入每日預算',
    ConfirmRecharge: '確認充值',
    ConfirmClear: '確認清空',
    AddAccount: '添加賬戶',
    BCID: 'BCID',
    EnterBCID: '請輸入BC ID',
    SelectBCID: '請選擇BC ID',
    Email: '郵箱',
    EnterEmail: '請輸入郵箱',
    EnterEmail2: '請輸入正確郵箱',
    SelectEmail: '請選擇郵箱',
    Permission: '權限',
    SelectPermission: '請選擇權限',
    AccountSearch: '請輸入帳號名稱搜索添加',
    Select: '選擇',
    Transfer: '賬戶減款轉賬申請',
    AccountBalance: '賬戶余額',
    EstimatedAeductibleAmount: '預估可減款金額',
    TransferID: '轉出賬戶名稱/ID',
    Type: '類型',
    TransferAccount: '轉賬',
    TransferAmount: '减款',
    TransferMoney: '轉出金額',
    EnterTransferAmount: '請輸入轉出金額',
    IsOut: '是否全部轉出',
    Clear: '清零',
    TransferredAccount: '轉入賬戶',
    SelectTransferAccount: '請選擇轉入賬戶',
    BindBC: '綁定BC',
    UnbindBC: '解綁BC',
    BindEmail: '綁定郵箱',
    UnbindEmail: '解綁郵箱',
    EnableMonitoring: '開啟監控',
    AddMonitoring: '新增監控',
    Edit: '編輯',
    Duration: '開戶時長（天）',
    AccountOpeningTime: '開戶時間',
    banTime: '封戶時間',
    Budget: '預算金額',
    budgetCost: '已消耗金額',
    BatchAdd: '批量添加',
    BatchOpen: '批量開啟',
    ConfirmOpen: '確認開啟',
    ConfirmClose: '確認關閉',
    BatchClose: '批量關閉',
    BudgetAmount: '預算金額',
    CircuitTime: '巡回時間',
    CircuitTimeTip: '請輸入巡回時間',
    BudgetAmountTip: '請輸入預算金額',
    Num: '剩餘次數',
  },AccountRecord:{
    Add:'添加賬戶',
    batchAdd: '批量添加賬戶',
    MediaAccount: '媒體帳號',
    AccountPlacement: '投放帳號',
    SeriesName: '廣告系列名稱',
    SeriesNamePrompt: '填寫廣告系列名稱',
    SeriesStatus: '廣告系列狀態',
    BudgetStatus: '推廣系列預算優化',
    GroupName: '廣告組名稱',
    PlGroupName: '填寫廣告組名稱',
    GroupStatus: '廣告組狀態',
    DeliveryMethod: '創意投放方式',
    AccountName:'帳號名稱',
    MediaPlatform:'媒體平台',
    MonitoringAmount:'監控金額',
    RechargeAmount:'充值金額',
    CircuitTime:'巡回時間',
    State:'狀態',
    Modify:'修改',
    Delete:'刪除',
    Operate:'操作',
    IsDelete:'是否確認刪除',
    SelectMediaPlatform:'請選擇媒體平台',
    TransferAccount:'轉入賬戶',
    SelectTransferAccount:'請選擇轉入賬戶',
    MonitoringBalance:'監控餘額',
    PutMonitoringBalance:'請輸入監控賬戶餘額',
    PutRechargeAmount:'請輸入充值金額',
    MaximumTwoDecimal:'最大兩位小數',
    IntervalTime:'間隔時間',
    PutIntervalTime:'請輸入多少小時輪巡',
    Hours:'小時',
    Cancellation:'取消',
    Submit:'提交',
    PleaseEnterInteger:'請輸入整數',
    SuccessfullyDeleted:'成功刪除',
    accountStatus: '賬戶狀態',
    BudgetBalance: '預算餘額',
    AdvertisingAccountBalance: '廣告賬戶餘額',
    MonitoringTime: '已監控時長(h)',
    StopDays: '停止天數(天)',
    TourTime: '巡回時間',
    MonitoringStatus: '監控狀態',
    Remark: '備註',
    Media: '媒體平台',
    Status: '狀態',
    AccountEntity: '開戶主體',
    ApplyNumber: '申請ID',
    PromotionLink: '推廣鏈接',
    StartTime: '開始時間',
    EndTime: '結束時間',
    Reset: '重置',
    Search: '搜索',
    Export: '導出',
    AccountApplicationID: '公司名稱/申請ID',
    CreatedTime: '申請時間',
    AccountInfo: '賬戶信息',
    AccountID: '賬戶id',
    CompanyName: '企業名稱',
    Currency: '幣種',
    AccountBalance: '賬戶余額',
    View: '查看',
    ViewAccount: '查看賬戶',
    Edit: '修改',
    Copy: '複制',
    RechargeTips: '溫馨提示：未充值的廣告賬戶搭建廣告計劃容易引起封戶，請您先給廣告賬戶充值，謝謝',
  },AccountRecharge:{
    Add:'添加賬戶',
    batchAdd: '批量添加賬戶',
    MediaAccount: '媒體帳號',
    AccountPlacement: '投放帳號',
    SeriesName: '廣告系列名稱',
    SeriesNamePrompt: '填寫廣告系列名稱',
    SeriesStatus: '廣告系列狀態',
    BudgetStatus: '推廣系列預算優化',
    GroupName: '廣告組名稱',
    PlGroupName: '填寫廣告組名稱',
    GroupStatus: '廣告組狀態',
    DeliveryMethod: '創意投放方式',
    AccountName:'帳號名稱',
    MediaPlatform:'媒體平台',
    MonitoringAmount:'監控金額',
    RechargeAmount:'充值金額',
    CircuitTime:'巡回時間',
    State:'狀態',
    Modify:'修改',
    Delete:'刪除',
    Operate:'操作',
    IsDelete:'是否確認刪除',
    SelectMediaPlatform:'請選擇媒體平台',
    TransferAccount:'轉入賬戶',
    SelectTransferAccount:'請選擇轉入賬戶',
    MonitoringBalance:'監控餘額',
    PutMonitoringBalance:'請輸入監控賬戶餘額',
    PutRechargeAmount:'請輸入充值金額',
    MaximumTwoDecimal:'最大兩位小數',
    IntervalTime:'間隔時間',
    PutIntervalTime:'請輸入多少小時輪巡',
    Hours:'小時',
    Cancellation:'取消',
    Submit:'提交',
    PleaseEnterInteger:'請輸入整數',
    SuccessfullyDeleted:'成功刪除',
    accountStatus: '賬戶狀態',
    BudgetBalance: '預算餘額',
    AdvertisingAccountBalance: '廣告賬戶餘額',
    MonitoringTime: '已監控時長(h)',
    StopDays: '停止天數(天)',
    TourTime: '巡回時間',
    MonitoringStatus: '監控狀態',
    Remark: '備註'
  },AccountDetails:{ //開戶詳情
    AdvertiserIdPlaceholder:"請輸入廣告帳戶ID",
    AdvertiserName: "請輸入廣告名稱",
    Reset:"重置",
    Search:"蒐索",
    StaticA:"統計資料：總花費：",
    StaticB:"，總廣告展現次數：",
    StatTimeDay:"日期",
    AdvertiserId:"廣告帳號名稱/廣告帳戶ID",
    Spend:"總消耗金額",
    Impressions:"廣告展現次數",
    Balance: "賬戶餘額",
    advertiserStatus: "賬戶狀態",
    DocumentInformation:'單據信息',
    ApplicationID:'申請ID',
    MediaPlatform:'媒體平台',
    CreationTime:'創建時間',
    AccountInformation:'賬戶信息',
    AccountType:'賬戶類型',
    Industry:'行業',
    DeliveryCountry:'投放國家',
    AccountTimeZone:'賬戶時區',
    AccountAuthorization:'賬戶授權',
    PromotionLink:'推廣鏈接',
    Authorization:'授權',
    Number:'序號',
    EmailID:'授權郵箱/商務中心id',
    Permission:'權限',
    EnterpriseInformation:'企業信息',
    CompanyName:'開戶公司名稱（中文）',
    LicenseCode:'營業執照社會信用代碼',
    License:'營業執照附件'
  },CheckWallet:{
    WalletRechargeOrder:'錢包充值訂單',
    AdvertisingTransactionOrders:'廣告交易訂單',
    AdvertisingConsumptionDetails:'廣告消耗明細',
    WalletRecharge:'錢包充值',
    RechargeAmount:'充值金額',
    EnterRechargeAmount:'請輸入充值金額',
    PaymentMethod:'支付方式',
    SelectPaymentMethod:'請選擇支付方式',
    Cancellation:'取消',
    ConfirmRecharge:'確認充值',
    AdvertiserIdPlaceholder:"請輸入廣告帳戶ID",
    Reset:"重置",
    Search:"蒐索",
    StaticA:"統計資料：總花費：",
    StaticB:"，總廣告展現次數：",
    StatTimeDay:"日期",
    AdvertiserId:"廣告帳號名稱/廣告帳戶ID",
    Spend:"花費",
    Impressions:"廣告展現次數",
  },CheckBalance:{ // 錢包明細
    OrderNumber:'訂單號',
    ChangeType:'變更類型',
    OperationType:'操作類型',
    Reset:'重置',
    Search:'搜索',
    PreChangeAmount:'變更前金額',
    ChangeAmount:'變更金額',
    AmountAfterChange:'變更後金額',
    Remarks:'備注',
  },CheckCredit:{ // 錢包明細
    OrderNumber:'訂單號',
    ChangeType:'變更類型',
    OperationType:'操作類型',
    Reset:'重置',
    Search:'搜索',
    PreChangeAmount:'變更前金額',
    ChangeAmount:'變更金額',
    AmountAfterChange:'變更後金額',
    Remarks:'備注',
    MainContent: '主要內容',
  },CheckAD:{ // 广告交易订单
    AccountType: '帳號類型',
    OrderNumber:'訂單號',
    AdvertisingName:'廣告名稱',
    OperationType:'操作類型',
    Status:'狀態',
    TransferStatus:'轉帳狀態',
    Reset:'重置',
    Search:'蒐索',
    PlatformType: '平臺類型',
    Account: '金額',
    TransferPlatform:'轉帳廣告帳戶平臺',
    TransferPlatformId:'轉帳廣告帳戶名稱/轉帳廣告帳戶Id',
    AccountId:'廣告帳戶名稱/廣告帳戶Id',
    Remarks:'備註',
    CreatedAt:'交易時間',
  },CheckPay:{ // 钱包充值订单
    Sn: '訂單號',
    Status:'訂單狀態',
    Reset:'重置',
    Search:'蒐索',
    CurrencyName: '幣種',
    PayTypeName: '支付方式',
    Amount: '充值金額',
    ExpiresAt:'訂單過期時間',
    PayTime:'支付時間',
    Operate:'操作',
    ImmediatePayment:'立即支付',
  },Settings:{
    Account:"帳號資訊",
    Company:"公司資訊",
    EmailBind:"郵箱綁定",
    PasswordUpdate:"密碼修改",
    Avatar:"頭像",
    Nickname:"用戶昵稱",
    NicknamePlaceholder:"請輸入用戶昵稱",
    NicknameRule:"用戶昵稱長度只支持（3~20）",
    SubmitForm:'提交',
    Upload:"圖片不能超過10M",
    UpdateSuccess:"修改成功",
    EnterpriseName:"企業名稱",
    EnterpriseEmail:"企業郵箱",
    EnterprisePhone:"連絡人電話",
    EnterpriseAddress:"企業地址",
    EnterpriseNamePlaceholder:"請輸入企業名稱",
    EnterpriseEmailPlaceholder:"請輸入企業郵箱",
    EnterprisePhonePlaceholder:"請輸入連絡人電話",
    EnterpriseAddressPlaceholder:"請輸入企業地址",
    Email:"郵箱",
    OldEmailCode:"郵箱驗證碼",
    OldEmailCodePlaceholder:"請輸入綁定郵箱驗證碼",
    SendSms :"發送驗證碼",
    BindEmail:"綁定郵箱",
    BindEmailPlaceholder:"請輸入綁定郵箱",
    BindEmailCode:"郵箱驗證碼",
    BindEmailCodePlaceholder:"請輸入郵箱驗證碼",
    SendCodeSuccess:"成功發送驗證碼",
    EmailBindSuccess:"郵箱綁定成功",
    EmailBindCodePlaceholder:"請輸入郵箱驗證碼",
    EmailSuccess:"請輸入正確郵箱",
    OldPassword:"老密碼",
    OldPasswordPlaceholder:"請輸入老密碼",
    Password:"新密碼",
    PasswordPlaceholder:"請輸入新密碼",
    RePassword:"確認密碼",
    RePasswordPlaceholder:"請輸入確認密碼",
    PasswordUpdateSuccess:"密碼修改成功",
  }
  ,Help:{
    ReleaseTime:"發佈時間",
    Title:"標題",
  },Other:{
    TikTokPlatform:"TikTok平台-開戶申請",
    NewQualification:"新資質",
    VerifiedQualifications:"已驗證資質",
    SelectVerifiedQualification:"選擇已驗證的資格證明以便再次使用",
    AutomaticallyReview:"使用已驗證的資格證明所建立的廣告帳號將自動通過審核",
    SelectVerifiedQualifications:"請選擇已驗證資格",
    AdvertisingAccounts:"個廣告帳號",
    AdvertisingArea:"廣告投放地區",
    PleaseSelectAdvertising:"請選擇廣告投放地區",
    NumberApp:"申請數量",
    PleaseNumberApp:"請輸入申請數量",
    LegalPerson:"法人姓名",
    PleaseLegalPerson:"請輸入法人姓名",
    IDNumber:"法人身分證",
    PleaseIDNumber:"請輸入法人身分證",
    BankAccountNumber:"法人銀行帳號",
    PleaseBankAccountNumber:"請輸入法人銀行帳號",
    BankMobileNumber:"法人手機",
    PleaseBankMobileNumber:"請輸入法人手機",
    AccountSelection:"帳號選擇",
    FormEntry:"表格輸入",
    BulkAdvertisingAccounts:"可從excel直接複製廣告帳號ID，依序空格分隔，範例如下",
    BatchSearch:"批次搜尋",
    ConfirmSub:"確認提交",
    AddRunningAccount:"新增運作帳戶",
    MonitorStatus:"監控狀態",
    Balance:"餘額",
    ConfirmStop:"確認停止",
    RunAccountList:"運行帳戶清單",
    SearchRunAccount:"搜尋運行帳戶",
    BatchClose:"批次關閉操作",
    RemainingTimes:"今天剩餘轉帳次數",
    UKTimeZone:"註:清留意單一帳戶當天只能互轉20次，操作時間以英國時區為準~",
    PleaseEnterBalance:"請輸入餘額",
    PleaseBudgetBalance:'請輸入預算餘額',
    EditorialMonitor:'編輯監控',
    AdvertiseAccountID:'廣告帳號ID',
    ConfirmAdd:'確認添加',
    SearchAddAccount:'搜尋新增帳戶',
    AddEnableAccounts:'批次新增開啟帳號',
    OpenAccountList:'開啟帳戶清單',
    BatchOperations:'批次操作',
    Phone:'手機號碼',
    ReleaseArea:'投放地區',
    WeChatBind:'微信綁定',
    Bind:'綁定',
    UnBind:'解綁',
    SubCustomerAlias: '子客户别名',
    SubCustomers: '子客户',
    PleaseSubCustomerAlias: '请输入子客户别名',
    AccountBalance: '帳戶金額',
    KwaiPlatform: "Kwai平台-開戶申請",
    BusinessScope: "營業範圍",
    BusinessLicense: "營業範圍. 請與營業執照一致",
    AdType: "廣告帳號類型",
    EffectAdAccount: "效果廣告帳號",
    Industry: "投放內容所屬產業",
    SeleteIndustry: "請選擇投放內容所屬行業",
    ProductBrandName: "產品或品牌名稱",
    PleaseProductBrandName: "請輸入產品或品牌名稱",
    PleaseRregisAddress: "請輸入公司註冊地址",
    RregisAddress: "公司註冊地址",
    CheckEmail: "查看信箱",
    BindEmail: "綁定信箱",
    UnbindEmail: "解綁信箱",
    BindUnbindEmail: "綁定/解綁信箱",
    SerialNumber: "編號",
    BindStatus: "綁定狀態",
    GooglePlatform: "Google平台-開戶申請"
  },
  Omissions: {
    OnlineRecharge: '線上儲值',
    ActualAmount: '實付金額',
    SelectRechargeMethod: '選擇儲值方式',
    OnlinePay: '線上付款',
    OfflineTransfer: '線下轉帳',
    Recommend: '推薦',
    OnlinePayMethods: '人民幣儲值選擇線上付款方式，支援使用',
    USDPayoptions: '美元充值選擇線下轉賬，支援使用',
    RemainingBalance: '剩餘餘額',
    Increase: '增加',
    Decrease: '減少',
    ExchangeRate: '手續匯率',
    HandlingFees: '手續費',
    TransactionDetails: '交易詳情',
    TransactionID: '交易ID',
    TransactionVoucher: '交易憑證',
    Remark: '備註',
    DeductedBalance: '實扣餘額',
    MonitoringOn: '監控開啟',
    MonitoringOff: '監控關閉',
    MasterAccount: '主帳戶',
    SubAccount: '子帳戶',
    Username: '使用者名稱',
    AdvertiserNum: '廣告帳號數',
    CreditBalance: '授信餘額',
    LastLoginTime: '最後登入時間',
    BalanceAllocation: '餘額分配',
    AccountAllocation: '帳戶分配',
    ResetPassword: '重設密碼',
    UserDetail: '帳戶詳情',
    NewAccount: '新建帳號',
    LogRecording: '日誌記錄',
    AddSubUser: '新增子帳戶',
    PleaseName: '請輸入名稱（不超過五個欄位的名稱）',
    LoginPassword: '請輸入6-20位元登入密碼（需含大小寫字母）',
    ConfigPleasePassword: '請再輸入密碼',
    username: '使用者名稱',
    pleasePassword: '確認密碼',
    AdjustmentType: '調帳類型',
    Confirm: '確認',
    AssignedAdvertAccounts: '已指派廣告帳號',
    AddSubUserDetail: '子帳戶詳情',
    AllocatedAmount: '已分配金額',
    AdvertiserName: '帳號名稱',
    AdvertiserID: '帳號ID',
    ConsumedBalance: '已消耗餘額',
    SystemInfo: '系統資訊',
    CurrentWalletBalance: '目前錢包餘額',
    CurrentCreditBalance: '目前信用餘額',
    AdjustmentAmount: '調帳金額',
    PleaseAdjustmentAmount: '請輸入調帳金額',
    PleaseSelectType: '請選擇類型',
    MasterAccountBalance: '主帳戶餘額',
    MasterAccountCreditBalance: '主帳戶信用餘額',
    AccountRecycle: '帳戶回收',
    AccountRecycleList: '帳戶回收清單',
  },
  SubClient:{
    OnlineRecharge:'線上儲值',
    ProxyLinks:'代理連結',
    SubManagement:'子客戶管理',
    RiskControlStatus:'風控狀態',
    Normal:'正常',
    Disable:'禁用',
    Username:'使用者名稱',
    Mail:'郵箱',
    WalletBalance:'皮夾餘額',
    AccountBalance:'信用餘額',
    AdvertiserNumber:'廣告帳戶數量',
    Phone:'手機號',
    BalanceRecharge:'餘額儲值',
    BalanceReduction:'餘額減款',
    BasicInformation:'基本資訊',
    UserUpdate:'使用者更名',
    LinkAccounts:'關聯帳戶',
    TransactionRecords:'交易記錄',
    OpenRecords:'開戶記錄',
    UserId:'用戶ID',
    ReductionChannels:'減款管道',
    MyBalance:'我的餘額',
    SubClientBalance:'子客戶餘額',
    AmountReduction:'減款金額',
    PleaseAmountReduction:'請輸入減款金額',
    BalanceAfterDeduction:'減款後餘額',
    Remark:'備註',
    PleaseRemark:'請輸入備註',
    Recharge:'儲值',
    RechargeChannels:'儲值管道',
    RechargeAmount:'儲值金額',
    PleaseRechargeAmount:'請輸入儲值金額',
    BalanceAfterRecharge:'儲值後餘額',
    EditName:'編輯名稱',
    ChangeName:'變更名稱',
    SubClientname:'子客戶名稱',
    AdvertiserNum:'廣告數量',
    LoginRest:'登入限制',
    OpenRest:'開戶限制',
    AccountClosureRate:'帳號封戶率',
    LastLoginIP:'最後登入IP',
    LastLoginTime:'最近登入時間',
    Reduction: '減款',
    Operator: '操作人',
    TransactionAmount: '交易金額',
    CreditBalanceRecord: '信用餘額明細',
  },
  Notice: {
    BatchRead: '批量已讀',
    MessageStatus: '消息狀態',
    Title: '標題',
    Summary: '摘要',
    ReleaseTime: '發佈時間',
    MessageType: '消息類型',
    Operate: '操作',
    QueryDetails: '查詢詳情',
    Details: '詳情',
    PleaseEnterMessageTitle: '請輸入消息標題',
    All: '全部',
    Read: '已讀',
    Unread: '未讀',
    SystemNotice: '系統通知',
    OrdinaryNotice: '普通通知',
  },
  Zero:{
    ConfirmBatchZero: '確認批量清零',
    Reminder: '清零提醒',
    Prompt1: '1、最終轉出金額以平台實際金額為準',
    Prompt2: '2、最終清零金額以平台實際金額為準，實際清零的金額可在賬單管理的金額變動記錄查看處理進度，處理時間需要1-3個工作日',
    Prompt3: '3、目前清零僅支援封戶的廣告帳號',
  },
  Partner:{
    marketingToolintro: '专注TIKTOK生态效率工具开发，更懂TIKTOK达人带货生态',
    crossBorderBrowserintro: '站斧浏览器专为每个账号提供安全独立运营环境',
    storeOperationToolsintro: '专注TIKTOK生态效率工具开发，更懂TIKTOK达人带货生态',
    USCloudPhoneintro: 'Ushop店铺智能管理ERP',
    TermsService: '工具推荐系列为东坤科技Adseasy的合作方提供服务，非本平台服务，请确认对应平台的服务内容以及协议后使用',
    serviceRecommendation: '服务推荐',
    marketingToolDetail: '稳定批量邀约/私信达人，每天触达上万达人；免费提供千万+精准带货达人库、内置AI生成话术，支持多语言AI辅助回复达人；支持邮件群发等多种站内外方式触达；洞悉竞品、同行店铺的带货达人，达秘一键触达、附带达人管理系统，邀约管理流程SOP化。',
    crossBorderBrowserDetail: '立即注册，新用户享无门槛券体验；安全高效运营店铺；站斧浏览器专为每个账号提供安全独立运营环境。',
    storeOperationToolsDetail: '致力于打造AI自动化电商管理运营系统工具，支持TikTok、Lazada、Shopee、Shein等多家电商平台本土及跨境店铺。',
    USCloudPhoneDetail: '毫秒级响应·从未如此流畅；支持平台:拼多多、抖店、淘宝网、Shopee、Paypal、Tiktok等众多平台 ；云号管理井然有序 ；信息传输快人一步。',
  },
  MonthSettlement: {
    list: '月結列表',
    enterpriseName: '公司名稱',
    monthBill: '帳單月份',
    money: '本期帳單金額',
    file: '下載',
    createdAt: '生成時間',
    remark: '備註',

  }

}